module.exports = __webpack_public_path__ + "media/images/application/favicon/safari-pinned-tab-fffa54333971e56e013b526a59d8591b.svg";